import { Observer } from '../global/gsap';

const initHomeSpeakers = (wrapper) => {
    let mouseX = 0;
    let mouseY = 0;

    const mediaWrap = wrapper.querySelector('.js-speaker-media');

    const hideMedia = () => {
        mediaWrap.classList.remove('active');
    };

    const showMedia = () => {
        mediaWrap.classList.add('active');
    };

    let activeTarget = null;

    const imagesTo = (target, x, y) => {
        if (x) {
            mouseX = x;
        }

        if (y) {
            mouseY = y;
        }

        if (!target) {
            target = document.elementFromPoint(mouseX, mouseY);
        }

        if (target.classList.contains('js-speaker')) {
            showMedia();

            if (target.dataset.count !== activeTarget) {
                activeTarget = target.dataset.count;

                const images = wrapper.querySelectorAll('.js-speaker-image');
                const activeImage = wrapper.querySelector(`.js-speaker-image[data-count="${activeTarget}"]`);

                images.forEach((image) => {
                    image.classList.remove('active');
                });

                if (activeImage) {
                    activeImage.classList.add('active');
                }
            }
        } else {
            hideMedia();
        }
    };

    Observer.create({
        target: document,
        type: 'pointer, wheel',
        tolerance: 1,
        onWheel: () => {
            imagesTo();
        },
        onMove: (self) => {
            imagesTo(self.event.target, self.x, self.y);
        }
    });
};

export { initHomeSpeakers as default };
